export default __webpack_public_path__ + "static/media/convert.3bce5e34.svg";